"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistanceMeasureState = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const core_shared_1 = require("@ikegps/core-shared");
class DistanceMeasureState {
    constructor() {
        this.points = [];
        this.isActive = false;
    }
    setActive(active) {
        this.isActive = active;
        if (!active) {
            this.clearPoints();
        }
    }
    /**
     * Add a measurement point. If two points already exist, clear them first
     * so the new click becomes the start of a fresh measurement.
     */
    addPoint(point) {
        if (this.points.length >= 2) {
            this.points = [];
        }
        this.points.push(point);
    }
    updatePointLocation(id, location) {
        const point = this.points.find((p) => p.id === id);
        if (point) {
            point.location = location;
        }
    }
    clearPoints() {
        this.points = [];
    }
    reset() {
        this.points = [];
        this.isActive = false;
    }
    /** Only call when points.length >= 2 */
    getVector() {
        const a = this.points[0];
        const b = this.points[1];
        return core_shared_1.IkeGeodesic.getVector({ latitude: a.location.lat(), longitude: a.location.lng(), altitude: 0 }, { latitude: b.location.lat(), longitude: b.location.lng(), altitude: 0 });
    }
    /** Distance between the two points in meters, or 0 if fewer than 2 points */
    get distance() {
        if (this.points.length < 2) {
            return 0;
        }
        return this.getVector().distance;
    }
    /** Bearing from point A to point B in degrees (0–360), or 0 if fewer than 2 points */
    get bearing() {
        if (this.points.length < 2) {
            return 0;
        }
        return core_shared_1.IkeAngle.toDegrees(this.getVector().bearing);
    }
}
exports.DistanceMeasureState = DistanceMeasureState;
tslib_1.__decorate([
    mobx_1.observable
], DistanceMeasureState.prototype, "points", void 0);
tslib_1.__decorate([
    mobx_1.observable
], DistanceMeasureState.prototype, "isActive", void 0);
tslib_1.__decorate([
    mobx_1.action.bound
], DistanceMeasureState.prototype, "setActive", null);
tslib_1.__decorate([
    mobx_1.action.bound
], DistanceMeasureState.prototype, "addPoint", null);
tslib_1.__decorate([
    mobx_1.action.bound
], DistanceMeasureState.prototype, "updatePointLocation", null);
tslib_1.__decorate([
    mobx_1.action.bound
], DistanceMeasureState.prototype, "clearPoints", null);
tslib_1.__decorate([
    mobx_1.action.bound
], DistanceMeasureState.prototype, "reset", null);
tslib_1.__decorate([
    mobx_1.computed
], DistanceMeasureState.prototype, "distance", null);
tslib_1.__decorate([
    mobx_1.computed
], DistanceMeasureState.prototype, "bearing", null);
//# sourceMappingURL=distance.measure.state.js.map